<template>
  <div class="mt-5">
    <div class="vx-col  w-auto m-10 mb-base">
      <vs-card>
        <div class="p-6 w-full md:w-1/2">
          <div class="vx-col w-full mt-5 vs-con-loading__container">
            <template v-if="logo">
              <!-- Image Container -->
              <div class="w-64 flex items-center">
                <img :src="logo" alt="img" class="responsive" />
              </div>

              <!-- Image upload Buttons -->
              <div class="modify-img flex mt-5">
                <input
                  type="file"
                  class="hidden"
                  ref="updateImgInput"
                  @change="updateCurrImg"
                  accept="image/*"
                />
                <vs-button
                  class="mr-4"
                  href="#"
                  @click="$refs.updateImgInput.click()"
                  >Update Logo</vs-button
                >
                <vs-button color="danger" @click="logo = null"
                  >Remove Logo</vs-button
                >
              </div>
            </template>
          </div>

          <div class="upload-img mt-5" v-if="!logo">
            <input
              type="file"
              class="hidden"
              ref="uploadImgInput"
              @change="updateCurrImg"
              accept="image/*"
            />
            <vs-button @click="$refs.uploadImgInput.click()"
              >Upload Logo</vs-button
            >
          </div>
          <!-- Director-->
          <div class="vx-col w-full mt-5">
            <label class="block mb-2">Director Name</label>
            <v-select
              :options="directorOptions"
              :clearable="false"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="directorFilter"
              class="mb-4 md:mb-0"
            />
          </div>
          <!-- NAME -->
          <div class="vx-col w-full mt-5">
            <vs-input
              label="Centre Name"
              v-model="companyName"
              class="w-full"
              name="companyName"
              v-validate="'required'"
              data-vv-as="Centre name"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('companyName')"
              >{{ errors.first("companyName") }}</span
            >
          </div>

          <!-- Age Group -->
          <!-- <div class="vx-col w-full mt-5">
            <label class="vs-input--label">Age Group</label>
            <v-select
              :options="ageOptions"
              :clearable="false"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="ageFilter"
              class="mb-4 md:mb-0"
              data-vv-as="Age Group"
            />
          </div> -->
          <div class="vx-col w-full mt-5">
            <vs-input
              label="Phone Number"
              v-model="contactNumber"
              class="mt-5 w-full"
              name="contactNumber"
              v-validate="'required|numeric'"
              data-vv-as="phone number"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('contactNumber')"
              >{{ errors.first("contactNumber") }}</span
            >
          </div>
          <div class="vx-col w-full mt-5">
            <vs-input
              class="w-full mt-5"
              name="email"
              v-validate="'required|email'"
              label="Email"
              v-model="email"
              data-vv-as="Email"
            />
            <span class="text-danger text-sm" v-show="errors.has('email')">{{
              errors.first("email")
            }}</span>
          </div>

          <div class="vx-col w-full mt-5">
            <label class="vs-input--label">Country</label>
            <v-select
              :options="countryOptions"
              :clearable="false"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="countryFilter"
              @input="onStateChange"
              class="mb-4 md:mb-0"
              name="country"
          />
          <span class="text-danger text-sm" v-show="errors.has('country')">{{
            errors.first("country")
          }}</span>
          </div>

          <div class="vx-col w-full mt-5">
            <label class="vs-input--label">State</label>
            <v-select
              :options="stateOptions"
              :clearable="false"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="stateFilter"
              @input="onStateChange"
              class="mb-4 md:mb-0"
              data-vv-as="State"
              name="state"
          />
          <span class="text-danger text-sm" v-show="errors.has('state')">{{
            errors.first("state")
          }}</span>
          </div>

          <div
            vs-type="flex"
            vs-justify="left"
            vs-align="left"
            vs-w="6"
            class="mt-5"
          >
            <div class="w-full">
              <label class="vs-input--label">Street Address</label>
              <input
                type="text"
                placeholder
                ref="autocomplete"
                v-validate="'required'"
                data-vv-as="Street Address"
                name="streetAddress"
                v-model="streetAddress"
                class="vs-inputx vs-input--input normal"
                :class="{ hasValue: streetAddress }"
              />
            </div>
          </div>
          <span
            class="text-danger text-sm"
            v-show="errors.has('streetAddress')"
            >{{ errors.first("streetAddress") }}</span
          >

          <vs-input
            label="Town/City"
            v-model="suburb"
            class="mt-5 w-full"
            name="suburb"
            v-validate="'required'"
            data-vv-as="Town"
          />
          <span class="text-danger text-sm" v-show="errors.has('suburb')">{{
            errors.first("suburb")
          }}</span>

          <vs-input
            label="Postcode"
            v-model="postCode"
            class="mt-5 w-full"
            name="postCode"
            v-validate="'required'"
            data-vv-as="Post Code"
          />
          <span class="text-danger text-sm" v-show="errors.has('postCode')">{{
            errors.first("postCode")
          }}</span>

          <label class="vs-input--label mt-5">Is Active?</label>
          <vs-switch v-model="isActive" />
          {{ isActive ? "Active" : "Inactive" }}
        </div>
        <div class="flex flex-wrap items-center p-6 w-full md:w-1/2">
          <vs-button
            class="ml-auto"
            @click="submitData"
            :disabled="!isFormValid"
            >Save</vs-button
          >
        </div>
      </vs-card>
    </div>
  </div>
</template>
<script
  type="text/javascript"
  async
  src="https://maps.googleapis.com/maps/api/js?key=AIzaSyD2_dLcglU5iyLUQ9hYiUuvpAyy7iRT3-o&libraries=places"
></script>
<script>
import vSelect from "vue-select";
import { mapActions } from "vuex";
import _ from "lodash";

export default {
  data() {
    return {
      dataId: null,
      directorId: "",
      companyName: "",
      contactNumber: "",
      fullName: "",
      email: "",
      logo: null,
      isActive: true,
      image: null,
      settings: {
        // perfect scrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      streetAddress: "",
      suburb: "",
      postCode: "",
      countryOptions: [],
      stateOptions: [],
      ageOptions: [],
      countryFilter: { label: "All", value: "all" },
      stateFilter: { label: "All", value: "all" },
      ageFilter: { label: "Select age group", value: "" },
      customError: "",
      address: {
        displayAddress: "",
        suburb: "",
        state: "",
        street: "",
        streetNumber: "",
        postCode: "",
        location: {
          type: "point",
          coordinates: []
        },
        addressData: []
      },
      checkDisplayAddress: "",
      directorOptions: [],
      directorFilter: { label: "All", value: "all" }
    };
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    countryFilter(obj) {
      this.stateOptions = obj.states;
    }
  },
  computed: {
    isFormValid() {
      return (
        !this.errors.any() &&
        this.companyName &&
        this.contactNumber &&
        this.email &&
        this.logo &&
        // this.countryFilter.value != "all" &&
        // this.stateFilter.value != "all" &&
        this.directorFilter.value != "all" &&
        this.streetAddress &&
        this.suburb &&
        this.postCode &&
        this.ageFilter.value != ""
      );
    }
  },
  async mounted() {
    this.$gmapApiPromiseLazy().then(async () => {
      this.autocomplete = await new google.maps.places.Autocomplete(
        this.$refs.autocomplete,
        { types: ["geocode"] }
      );

      this.autocomplete.addListener("place_changed", () => {
        let place = this.autocomplete.getPlace();
        this.errors.remove("streetAddress");
        let ac = place.address_components;
        this.address.addressData = place.address_components;
        this.address.addressData[0].checkDisplayAddress =
          place.formatted_address;
        this.checkDisplayAddress = place.formatted_address;
        let lat = place.geometry.location.lat();
        let lon = place.geometry.location.lng();
        this.address.displayAddress = place.formatted_address;
        this.streetAddress = place.formatted_address;
        this.address.location.coordinates[0] = lon;
        this.address.location.coordinates[1] = lat;
      });
    });
  },
  methods: {
    ...mapActions("center", [
      "updateCenter",
      "addCenter",
      "imageUpload",
      "getAllCountries",
      "getDirectorList",
      "getAgeGroup",
      "getCenterById"
    ]),
    place_changed(a) {},
    showMessage(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: color
      });
    },
    fetchDirectorList() {
      this.getDirectorList().then(res => {
        let data = res.data.data;
        this.directorOptions = data.map(item => {
          return {
            label: item.fullName,
            value: item._id
          };
        });
      });
    },
    async getDetails(id) {
      let self = this;
      await this.getCenterById(id)
        .then(async res => {
          let result = await res.data.data;
          self.dataId = result._id;
          self.companyName = result.name;
          self.email = result.email;
          self.isActive = result.isActive;
          self.contactNumber = result.phoneNumber;
          self.directorId = result.directorId;
          self.fullName = result.directorDetails[0].fullName;
          self.suburb = result.address.suburb;
          self.postCode = result.address.postCode;
          self.streetAddress = result.address.displayAddress;
          self.logo = result.logo;
          self.image = result.logo;
          self.stateFilter = {
            label: result.address.state,
            value: result.address.state
          };
          self.countryFilter = {
            label: result.country.name,
            value: result.country._id
          };
          self.getAllCountries().then(async res => {
            let filter = {
              label: self.countryFilter.label,
              value: self.countryFilter.label
            };
            let selectedCountry = _.find(res.data.data, filter);

            self.countryFilter = selectedCountry;
            self.stateOptions = await self.countryFilter.states;
          });
          self.ageFilter = {
            label: result.ageDetail[0],
            value: result.ageGroupId
          };
          self.directorFilter = {
            label: result.directorDetails[0].fullName,
            value: result.directorDetails[0]._id
          };

          self.$vs.loading.close();
        })
        .catch(err => {
          self.$vs.loading.close();
          //console.error(err)
        });
    },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        this.image = input.target.files[0];
        var reader = new FileReader();
        reader.onload = e => {
          this.logo = e.target.result;
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    onStateChange() {
      this.errors.clear();
    }, 
    async submitData() {
      await this.$validator.validateAll().then(result => {
        if (result) {
          if (this.countryFilter.value == "all") {
            this.errors.add({
                  field: "country",
                  msg: "Country can't be 'All'"
            });
          return;
          }
          if (this.stateFilter.value == "all") {
            this.errors.add({
                  field: "state",
                  msg: "State can't be 'All'"
            });
          return;
          }
          let data = new FormData();
          data.append("id", this.dataId);
          data.append("name", this.companyName);
          data.append("phoneNumber", this.contactNumber);
          data.append("directorId", this.directorFilter.value);
          data.append("fullName", this.directorFilter.label);
          data.append("email", this.email);
          data.append("logo", this.image);
          data.append("isActive", this.isActive);
          data.append("state", this.stateFilter.value);
          data.append("age", this.ageFilter.value);
          data.append("displayAddress", this.streetAddress);
          let sA = this.streetAddress.split(",");
          data.append("streetAddress", sA[0]);
          data.append("suburb", this.suburb);
          data.append("postCode", this.postCode);
          data.append("location", JSON.stringify(this.address.location));
          data.append("country", this.countryFilter.value);
          this.customError = "";
          if (this.dataId !== null) {
            this.$vs.loading();
            this.updateCenter(data)
              .then(res => {
                this.showMessage(
                  "Success",
                  "Centre Updated successfully.",
                  "success"
                );
                this.$router.push({
                  name: "learning-centre-view",
                  params: { id: this.dataId }
                });
                this.$vs.loading.close();
              })
              .catch(err => {
                this.$vs.loading.close();
              });
          } else {
            if (this.logo == null) {
              this.customError = "Image field is required.";
              return;
            }
            this.$vs.loading();
            this.addCenter(data)
              .then(res => {
                if (res.status === 200) {
                  this.$vs.loading.close();
                  this.showMessage(
                    "Success",
                    "Centre added successfully.",
                    "success"
                  );
                  this.$router.push({ name: "learning-centre-list" });
                }
              })
              .catch(err => {
                this.$vs.loading.close();
                if (err.response.status === "422") {
                  this.showMessage(
                    "Failed",
                    err.response.data.message,
                    "danger"
                  );
                }
                if (err.response.status === 403) {
                  this.showMessage(
                    "Failed",
                    err.response.data.message,
                    "danger"
                  );
                }
                this.showMessage("Failed", "Failed to add centre", "danger");
              });
          }
        }
      });
    }
  },
  created() {
    let id = this.$route.params.id;
    if ("undefined" != typeof id) {
      this.getDetails(id);
    }
    this.getAgeGroup()
      .then(res => {
        this.ageOptions = res;
      })
      .catch(err => {});
    this.getAllCountries()
      .then(res => {
          this.countryOptions = this.$store.state.center.countryOptions;
      })
      .catch(err => {});
    this.fetchDirectorList();
  },
  components: {
    vSelect
  }
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
